// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import ReportsBarChart from "examples/Charts/BarCharts/ReportsBarChart";
import ReportsLineChart from "examples/Charts/LineCharts/ReportsLineChart";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";

// Data
import reportsBarChartData from "layouts/dashboard/data/reportsBarChartData";
import reportsLineChartData from "layouts/dashboard/data/reportsLineChartData";

// Dashboard components
import TopUsers from "layouts/dashboard/components/TopUsers";
import OrdersOverview from "layouts/dashboard/components/OrdersOverview";
import { apiGetDailyUserCnt, apiGetDailyPetCnt, apiGetTodayPetCntByBranch, apiGetTodayPetCntHour, apiGetTodayTop10Users, apiGetTotalPoints } from '../../api/dashboard.api'; // API 호출 함수 임포트
import { useData } from '../../hooks'
import React, { useState, useEffect } from 'react';

function Dashboard() {
  const { sales, tasks } = reportsLineChartData;
  const [userCnts, setUserCnts] = useState({ labels: [], datasets: { data: [] } });
  const [dailyPetCnts, setDailyPetCnts] = useState({ labels: [], datasets: { data: [] } });
  const [petCntByBranch, setPetCntByBranch] = useState({ labels: [], datasets: { data: [] } });
  const [petCntByHour, setPetCntByHour] = useState({ labels: [], datasets: { data: [] } });
  const [totalPoints, setTotalPoints] = useState({ labels: [], datasets: { data: [] } });
  const [loading, setLoading] = useState(true);
  const { user, appIsReady } = useData();

  useEffect(() => {
    getDailyusercnt();
    getDailyPetCnt();
    getTodayPetCntByBranch();
    getTodayPetCntHour();
    getTotalPoints();
  }, []);

  const getDailyusercnt = async () => {
    setLoading(true);
    try {
      const response = await apiGetDailyUserCnt(user.accessToken);
      console.log("response=" + JSON.stringify(response));
      if (response && response.data) {
        setUserCnts(response.data);
      } else {
        console.log('No data received');
      }
    } catch (error) {
      console.error('Failed to load UserCnts:', error);
    } finally {
      setLoading(false);
    }
  };

  const getDailyPetCnt = async () => {
    setLoading(true);
    try {
      const response = await apiGetDailyPetCnt(user.accessToken);
      console.log("response=" + JSON.stringify(response));
      if (response && response.data) {
        setDailyPetCnts(response.data);
      } else {
        console.log('No data received');
      }
    } catch (error) {
      console.error('Failed to load DailyPetCnts:', error);
    } finally {
      setLoading(false);
    }
  };

  const getTodayPetCntByBranch = async () => {
    setLoading(true);
    try {
      const response = await apiGetTodayPetCntByBranch(user.accessToken);
      console.log("response=" + JSON.stringify(response));
      if (response && response.data) {
        setPetCntByBranch(response.data);
      } else {
        console.log('No data received');
      }
    } catch (error) {
      console.error('Failed to load PetCntByBranch:', error);
    } finally {
      setLoading(false);
    }
  };

  const getTodayPetCntHour = async () => {
    setLoading(true);
    try {
      const response = await apiGetTodayPetCntHour(user.accessToken);
      console.log("response=" + JSON.stringify(response));
      if (response && response.data) {
        setPetCntByHour(response.data);
      } else {
        console.log('No data received');
      }
    } catch (error) {
      console.error('Failed to load PetCntByHour:', error);
    } finally {
      setLoading(false);
    }
  };

  const getTotalPoints = async () => {
    setLoading(true);
    try {
      const response = await apiGetTotalPoints(user.accessToken);
      console.log("response=" + JSON.stringify(response));
      if (response && response.data) {
        setTotalPoints(response.data);
      } else {
        console.log('No data received');
      }
    } catch (error) {
      console.error('Failed to load PetCntByHour:', error);
    } finally {
      setLoading(false);
    }
  };

  const calculatePercentageChange = (previous, current) => {
    if (previous === 0) {
      return current === 0 ? 0 : 100;
    }
    return ((current - previous) / previous) * 100;
  };

  const formatNumber = (number) => {
    return new Intl.NumberFormat('en-US', { style: 'decimal', maximumFractionDigits: 0 }).format(number);
  };


  // 오늘 날짜의 마지막 데이터와 어제 및 엊그제 데이터를 가져옵니다.
  const todayUserCount = userCnts.datasets.data[userCnts.datasets.data.length - 1] || 0;
  const yesterdayUserCount = userCnts.datasets.data[userCnts.datasets.data.length - 2] || 0;
  const dayBeforeYesterdayUserCount = userCnts.datasets.data[userCnts.datasets.data.length - 3] || 0;

  const todayPetCount = dailyPetCnts.datasets.data[dailyPetCnts.datasets.data.length - 1] || 0;
  const yesterdayPetCount = dailyPetCnts.datasets.data[dailyPetCnts.datasets.data.length - 2] || 0;
  const dayBeforeYesterdayPetCount = dailyPetCnts.datasets.data[dailyPetCnts.datasets.data.length - 3] || 0;

  const todayNewUsers = todayUserCount - yesterdayUserCount;

  const userGrowthPercentage = calculatePercentageChange(dayBeforeYesterdayUserCount, yesterdayUserCount);
  const petGrowthPercentage = calculatePercentageChange(dayBeforeYesterdayPetCount, yesterdayPetCount);

  return (
    <DashboardLayout>
      <DashboardNavbar isMini/>
      <MDBox py={3}>
        <MDBox mt={4.5}>
          <Grid container spacing={3}>
          <Grid item xs={12} md={6} lg={2}>
              <MDBox mb={1.5}>
                <ComplexStatisticsCard
                  color="error"
                  icon="attach_money"
                  title="R포인트 합계"
                  count={formatNumber(totalPoints.totalRPoint)}
                />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <MDBox mb={1.5}>
                <ComplexStatisticsCard
                  color="warning"
                  icon="attach_money"
                  title="M포인트 합계"
                  count={formatNumber(totalPoints.totalMPoint)}
                />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={2}>
              <MDBox mb={1.5}>
                <ComplexStatisticsCard
                  color="success"
                  icon="recycling"
                  title="오늘 펫투입수"
                  count={formatNumber(todayPetCount)}
                  percentage={{
                    color: petGrowthPercentage >= 0 ? "success" : "error",
                    amount: `${petGrowthPercentage.toFixed(2)}%`,
                    label: "어제 증가율",
                  }}
                />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={1.5}>
              <MDBox mb={1.5}>
                <ComplexStatisticsCard
                  color="info"
                  icon="person_add"
                  title="총회원수"
                  count={todayUserCount}
                  percentage={{
                    color: userGrowthPercentage >= 0 ? "success" : "error",
                    amount: `${userGrowthPercentage.toFixed(2)}%`,
                    label: "어제 증가율",
                  }}
                />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={1.5}>
              <MDBox mb={1.5}>
                <ComplexStatisticsCard
                  color="info"
                  icon="person_add"
                  title="오늘 가입"
                  count={todayNewUsers}
                  percentage={{
                    color: userGrowthPercentage >= 0 ? "success" : "error",
                    amount: `${userGrowthPercentage.toFixed(2)}%`,
                    label: "어제 증가율",
                  }}
                />
              </MDBox>
            </Grid>
          </Grid>
        </MDBox>
        <MDBox mt={4.5}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6} lg={5}>
              <MDBox mb={3}>
                <ReportsLineChart
                  color="success"
                  title="일별 펫 투입수"
                  description="최근 1개월간"
                  date=""
                  chart={dailyPetCnts}
                />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={5}>
              <MDBox mb={3}>
                <ReportsLineChart
                  color="info"
                  title="일별 사용자 추이"
                  description="최근 1개월간"
                  date=""
                  chart={userCnts}
                />
              </MDBox>
            </Grid>
            
            <Grid item xs={12} md={6} lg={5}>
              <MDBox mb={3}>
                <ReportsBarChart
                  color="warning"
                  title="지점별 펫 투입수"
                  description="오늘"
                  date=""
                  chart={petCntByBranch}
                />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={5}>
              <MDBox mb={3}>
                <ReportsBarChart
                  color="error"
                  title="시간별 펫 투입수"
                  description="오늘"
                  date=""
                  chart={petCntByHour}
                />
              </MDBox>
            </Grid>
          </Grid>
        </MDBox>
        <MDBox>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6} lg={4}>
              <TopUsers accessToken={user.accessToken} />
            </Grid>
          </Grid>
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Dashboard;